import { Component, inject, OnInit } from '@angular/core';
import { CheckoutStepComponent } from '../base/checkout-step.component';
import { CartListCheckoutConfigService } from '../../../../services/cart-list-checkout-config/cart-list-checkout-config.service';
import { gungGetPropertyOfObject, gungSetPropertyOfObject } from 'gung-common';
import { format, parse } from 'date-fns';
import { first } from 'rxjs';

@Component({
  selector: 'lib-delivery-dates-minimum-date',
  standalone: false,
  templateUrl: './delivery-dates-minimum-date.component.html',
  styleUrl: './delivery-dates-minimum-date.component.scss'
})
export class DeliveryDatesMinimumDateComponent extends CheckoutStepComponent implements OnInit {
  protected cartListCheckoutConfigService = inject(CartListCheckoutConfigService);

  ngOnInit(): void {
    this.onNextBtnClicked.pipe(first()).subscribe(() => {
      this.checkCheckoutDates();
    });
  }

  checkCheckoutDates() {
    const field = this.cartListCheckoutConfigService.deliveryDateField;
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    this.checkout.rows.map(r => {
      const rowDateString = gungGetPropertyOfObject(field, r.extra);
      if (rowDateString) {
        const rowDate = parse(rowDateString, this.cartListCheckoutConfigService.saveDateFormat, new Date());
        if (today > rowDate) {
          const newDate = format(today, this.cartListCheckoutConfigService.saveDateFormat);
          gungSetPropertyOfObject(r.extra, field, newDate);
        }
      }
    });
    this.stepDone.emit(this.checkout);
  }

  public isVisible(): boolean {
    return false;
  }
}
